interface IdleDeadline {
    didTimeout: boolean;
    timeRemaining: () => number;
}

type RequestIdleCallbackHandle = number;

type RequestIdleCallbackOptions = {
    timeout?: number;
};

type RequestIdleCallback = (
    callback: (deadline: IdleDeadline) => void,
    options?: RequestIdleCallbackOptions
) => RequestIdleCallbackHandle;

type CancelIdleCallback = (handle: RequestIdleCallbackHandle) => void;

/**
 * 兼容性所有浏览器的 requestIdleCallback
 * @param callback
 * @param options
 */
export const commonRequestIdleCallback: RequestIdleCallback = (callback, options) => {
    if ('requestIdleCallback' in window) {
        return (window as any).requestIdleCallback(callback, options);
    }
    const start = Date.now();
    return setTimeout(() => {
        callback({
            didTimeout: false,
            timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
        });
    }, 1);
};

/**
 * 兼容性所有浏览器的 cancelIdleCallback
 * @param handle
 */
export const commonCancelIdleCallback: CancelIdleCallback = (handle) => {
    if ('cancelIdleCallback' in window) {
        (window as any).cancelIdleCallback(handle);
    } else {
        clearTimeout(handle);
    }
};
